/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `0` - off
 * * `1` - momentum conservative
 * * `2` - energy conservative
 * * `3` - combined momentum and energy conservative
 * @export
 */
export const UseAdvection1dEnum = {
  OFF: 0,
  MOMENTUM_CONSERVATIVE: 1,
  ENERGY_CONSERVATIVE: 2,
  COMBINED_MOMENTUM_AND_ENERGY_CONSERVATIVE: 3,
} as const;
export type UseAdvection1dEnum = (typeof UseAdvection1dEnum)[keyof typeof UseAdvection1dEnum];

export function instanceOfUseAdvection1dEnum(value: any): boolean {
  for (const key in UseAdvection1dEnum) {
    if (Object.prototype.hasOwnProperty.call(UseAdvection1dEnum, key)) {
      if (UseAdvection1dEnum[key as keyof typeof UseAdvection1dEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function UseAdvection1dEnumFromJSON(json: any): UseAdvection1dEnum {
  return UseAdvection1dEnumFromJSONTyped(json, false);
}

export function UseAdvection1dEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UseAdvection1dEnum {
  return json as UseAdvection1dEnum;
}

export function UseAdvection1dEnumToJSON(value?: UseAdvection1dEnum | null): any {
  return value as any;
}

export function UseAdvection1dEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): UseAdvection1dEnum {
  return value as UseAdvection1dEnum;
}
